module.exports = __webpack_public_path__ + "media/images/contact_us_NC_logo_white-7d6d5248.png";